import { Grid } from '@mui/material'
import { SectionHeading } from 'Components/Section'
import { CommonPath, KoreanLanguagePath } from 'Constants/Navigation'
import { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { KoreanLanguageContext } from '../Context'
import {
  KoreanLanguageContentList,
  KoreanLanguageExemplarySections,
  KoreanLanguageList,
  KoreanLeadingSchoolCreateForm,
  KoreanLeadingSchoolList,
  KoreanLanguageSchoolCreateForm,
  KoreanSchoolYearlyCreateForm,
  KoreanSchoolYearlyStatisticsList,
  KoreanLanguageStatisticsSections,
  KoreanUniversityCreateForm,
  KoreanUniversityList,
} from '../Organisms'
import { useKoreanLanguageConfig } from 'Views/KoreanLanguage/Hooks'

export default () => {
  const navigate = useNavigate()
  const { schoolSectionAddTitle, exemplarySchoolSectionAddTitle, universitySectionAddTitle, contentAddTitle, subPath } =
    useKoreanLanguageConfig()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isLeadingSchoolCreateOpen, setIsLeadingSchoolCreateOpen] = useState(false)
  const [isUniversityCreateOpen, setIsUniversityCreateOpen] = useState(false)
  const [isYearlyCreateOpen, setIsYearlyCreateOpen] = useState(false)
  const [refreshVersion, setRefreshVersion] = useState(0)

  const isStatisticsSection = subPath === KoreanLanguagePath.statistics

  const onAddStatistics = useCallback(() => {
    setIsCreateOpen(prev => !prev)
  }, [])

  const onAddContent = useCallback(() => {
    navigate(`/${KoreanLanguagePath.main}/${subPath}/${CommonPath.add}`)
  }, [navigate, subPath])

  const onAddUniversities = useCallback(() => {
    setIsUniversityCreateOpen(prev => !prev)
  }, [])

  const onAddYearlyStatistics = useCallback(() => {
    setIsYearlyCreateOpen(prev => !prev)
  }, [])

  const onAddLeadingSchools = useCallback(() => {
    setIsLeadingSchoolCreateOpen(prev => !prev)
  }, [])

  const onCreated = useCallback(() => {
    setRefreshVersion(prev => prev + 1)
    setIsCreateOpen(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      refreshVersion,
      onCreated,
    }),
    [onCreated, refreshVersion],
  )

  if (isStatisticsSection) {
    return (
      <KoreanLanguageContext.Provider value={contextValue}>
        <Grid container>
          <Grid item xs={12}>
            <KoreanLanguageStatisticsSections
              contentAddTitle={contentAddTitle}
              schoolSectionAddTitle={schoolSectionAddTitle || 'Добавить школу'}
              universitySectionAddTitle={universitySectionAddTitle || 'Добавить университет'}
              yearlySectionAddTitle='Добавить годовую статистику'
              onAddContent={onAddContent}
              onAddStatistics={onAddStatistics}
              onAddUniversities={onAddUniversities}
              onAddYearlyStatistics={onAddYearlyStatistics}
              expandSchoolsSection={isCreateOpen}
              expandUniversitiesSection={isUniversityCreateOpen}
              expandYearlySection={isYearlyCreateOpen}
              contentBody={<KoreanLanguageContentList />}
              schoolsBody={
                <>
                  {isCreateOpen && (
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <KoreanLanguageSchoolCreateForm onCancel={() => setIsCreateOpen(false)} />
                      </Grid>
                    </Grid>
                  )}
                  <KoreanLanguageList />
                </>
              }
              universitiesBody={
                <>
                  {isUniversityCreateOpen && (
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <KoreanUniversityCreateForm onCancel={() => setIsUniversityCreateOpen(false)} />
                      </Grid>
                    </Grid>
                  )}
                  <KoreanUniversityList />
                </>
              }
              yearlyBody={
                <>
                  {isYearlyCreateOpen && (
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <KoreanSchoolYearlyCreateForm onCancel={() => setIsYearlyCreateOpen(false)} />
                      </Grid>
                    </Grid>
                  )}
                  <KoreanSchoolYearlyStatisticsList />
                </>
              }
            />
          </Grid>
        </Grid>
      </KoreanLanguageContext.Provider>
    )
  }

  if (subPath === KoreanLanguagePath.exemplary) {
    return (
      <KoreanLanguageContext.Provider value={contextValue}>
        <Grid container>
          <Grid item xs={12}>
            <KoreanLanguageExemplarySections
              contentAddTitle={contentAddTitle}
              schoolSectionAddTitle={exemplarySchoolSectionAddTitle || 'Добавить школу'}
              onAddContent={onAddContent}
              onAddSchools={onAddLeadingSchools}
              expandSchoolsSection={isLeadingSchoolCreateOpen}
              contentBody={<KoreanLanguageContentList />}
              schoolsBody={
                <>
                  {isLeadingSchoolCreateOpen && (
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <KoreanLeadingSchoolCreateForm onCancel={() => setIsLeadingSchoolCreateOpen(false)} />
                      </Grid>
                    </Grid>
                  )}
                  <KoreanLeadingSchoolList />
                </>
              }
            />
          </Grid>
        </Grid>
      </KoreanLanguageContext.Provider>
    )
  }

  return (
    <Grid container rowSpacing={4}>
      <Grid item xs={12}>
        <SectionHeading onAdd={onAddContent} addTitle={contentAddTitle} langFilter />
      </Grid>
      <Grid item xs={12}>
        <KoreanLanguageContentList />
      </Grid>
    </Grid>
  )
}